import { SvgIcon, SvgIconProps } from '@material-ui/core';
import React, { FC } from 'react';

export const SchedulerStageIcon: FC<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 3V2.75C11 2.33579 10.6642 2 10.25 2C9.83579 2 9.5 2.33579 9.5 2.75V3H6.5V2.75C6.5 2.33579 6.16422 2 5.75 2C5.3358 2 5.00002 2.33577 5.00001 2.74998L5 3H4C3.44772 3 3 3.44771 3 4L3 4.5H13V4C13 3.44772 12.5523 3 12.0001 3C11.6482 3 11.2729 3 11 3Z" />
    <path d="M3 6V12C3 12.5523 3.44772 13 4 13H12C12.5523 13 13 12.552 13 11.9997C13 9.87984 13 8.31758 13 6H3Z" />
  </SvgIcon>
);
